import permissions from './permissions.json';

// Matches combined-key permissions like 'createUser', 'editService', 'deleteExtraItem'
const COMBINED_KEY_PATTERN = /^(view|create|edit|delete)([A-Z][a-zA-Z]*)$/;

/**
 * hasPermission(currentUser, 'user', 'create')
 * hasPermission(currentUser, 'createUser')
 * hasPermission(role, 'user', 'create') // a role string also works
 */
export const hasPermission = (currentUser, resourceOrKey, action) => {
    const role = typeof currentUser === 'string' ? currentUser : currentUser?.role;
    if (!role) return false;

    let resource = resourceOrKey;
    let resolvedAction = action;

    if (resolvedAction === undefined) {
        const match = COMBINED_KEY_PATTERN.exec(resourceOrKey || '');
        if (!match) return false;
        resolvedAction = match[1];
        resource = match[2].charAt(0).toLowerCase() + match[2].slice(1);
    }

    const rolePermissions = permissions[role];
    if (!rolePermissions) return false;

    const allowedActions = rolePermissions[resource];
    if (!allowedActions) return false;

    return allowedActions.includes(resolvedAction);
};

export default hasPermission;
